import { ViewChild, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';
import { AutoTableComponent } from '@ngx-resource-toolkit/core';

export class BaseTableSizeComponent implements OnInit, OnDestroy {

    @ViewChild('searchFormPanel') searchFormPanel;
    @ViewChild('searchTableResult') searchTableResult: AutoTableComponent;

    public tableHeight = 200;

    isTableReady = false;
    pageReady = new BehaviorSubject<boolean>(null);

    private headerHeight = 60;
    private footerHeight = 60;
    private margins = 2 * 20;
    private paddings = 15;

    private subscription: Subscription;

    fullScreenChanged() {
        this.computeTableHeight();
    }
    ngOnInit(): void {
        const that = this;
        /*document.addEventListener('fullscreenchange', function() {
            that.fullScreenChanged();
        });*/ // le recalcul au changement de taiulle de la fenêtre suffit
        window.onresize = function() {
            that.fullScreenChanged();
        };
        this.isTableReady = false;
        this.subscription = this.pageReady.subscribe(ready => {
            if (ready) {
                setTimeout(() => this.computeTableHeight(), 0);
            }
        });
    }
    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    computeTableHeight() {
        // Récupération de la hauteur de l'élément
        let height = document.fullscreenElement ? screen.height : document.body.offsetHeight;
        /*console.log({
            height,
            screenHeight: screen.height,
            bodyoffsetHeight: document.body.offsetHeight,
            offsetHeight: this.searchFormPanel.nativeElement.offsetHeight,
            headerHeight: this.headerHeight,
            footerHeight: this.footerHeight,
            margins: this.margins,
            paddings: this.paddings,
            fullscreen: document.fullscreenElement,
        });*/
        height -= this.searchFormPanel.nativeElement.offsetHeight;
        height -= this.headerHeight;
        height -= this.footerHeight;
        height -= this.margins;
        height -= this.paddings;

        this.tableHeight = Math.max(height, 200); // (height > 250 ? height : 250);
        // console.log({ offsetHeight: document.body.offsetHeight, height, tableHeight: this.tableHeight });
        if (this.searchTableResult) {
            this.searchTableResult.recalculate();
            // console.log('searchTableResult recalculé');
        }

        this.isTableReady = true;
        // console.log({tableHeight: this.tableHeight, screenheight: screen.height, bodyoffsetHeight: document.body.offsetHeight, fullscreen: document.fullscreenElement ? 'oui' : 'non'});

        // console.log('BaseTableSizeComponent.tableHeight : ', {
        //     tableheight: this.tableHeight,
        //     formpanel: this.searchFormPanel.nativeElement.offsetHeight,
        //     body: document.body.offsetHeight,
        // });
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/components/base-table-size.component.ts